import React from 'react';
import { CalendarMonthButton } from './CalendarMonthButton';

interface CalendarHeaderProps {
    year: number;
    month: number;
    locale: string;
    onPrev: () => void;
    onNext: () => void;
}

export const CalendarHeader = React.memo(
    ({ year, month, locale, onPrev, onNext }: CalendarHeaderProps) => (
        <div className="flex justify-between">
            <CalendarMonthButton
                onClick={onPrev}
                direction="prev"
                date={new Date(year, month - 2)}
                locale={locale}
            />
            <div>
                <h2 className="text-center text-2xl font-bold text-backgroundGreen">
                    {new Date(year, month - 1).toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric',
                    })}
                </h2>
            </div>
            <CalendarMonthButton
                onClick={onNext}
                direction="next"
                date={new Date(year, month)}
                locale={locale}
            />
        </div>
    )
);
